// Custom Quick view GA4 View_item event
document.addEventListener("click", async function (e) {
   const btn = e.target.closest(".js-quick-add");
  if (!btn || btn.dataset.action === "add-to-cart") return;

  const productId = btn.dataset.product;
  const productUrl = btn.dataset.productUrl; 
  const productHandle = productUrl.split("/products/")[1];

  let productData = null;
  try {
    const res = await fetch(`/products/${productHandle}.js`);
    productData = await res.json();
  } catch (err) {
    console.warn("Unable to fetch product details", err);
  }
 
  const payload = {
    id: productId,
    handle: productHandle,
    title: productData?.title || "",
    price: productData?.price || 0,
    vendor: productData?.vendor || "",
    type: productData?.type || "",
    variant: productData?.variants?.[0]?.title || "",
    currency: Shopify.currency.active
  };

  if (window.Shopify?.analytics?.publish) {
    Shopify.analytics.publish("quick_view", payload);
    console.log("Custom Quick View Event Published", payload);
  } else {
    console.warn(" Shopify.analytics.publish not available");
  }
});

// custom lead event for HubSpot forms
(function () {
  const path = window.location.pathname;

  const currentPageConfig = {
      form_id: "custom-lead-forms",
      form_name: "CTC Custom Event Lead Form",
      lead_category: "signup"
  };

//   const currentPageConfig = pageConfig[path];
//   if (!currentPageConfig) return;

  window.addEventListener("message", (event) => { 
    if (!event.data) return;
    if (
      event.data.type === "hsFormCallback" &&
      event.data.eventName === "onFormSubmitted"
    ) {

      console.log("event",event);
      const values = event.data.data?.submissionValues || {};

      let form_name = "Newsletter";
      let form_category = "signup";

      if(event.data.id == "d0130aa4-7289-42b7-bdb1-5dee275e186b"){
        form_name = "CTC Contact Us Form";
        form_category = "contact";
      }
      if(event.data.id == "6e3aa8da-0cb0-4189-b28e-ea95786ee482"){
        form_name = "MKT CTCCON25 US SMS Opt-In for Pop-up";
      }
      if(event.data.id == "0e8cdbc9-5eed-4c07-b8df-1d90d0511adc"){
        form_name = "CTCCON25 US Contractor Newsletter Sign Up NO DISCLAIMER FOR LANDING PAGE";
      }

      const payload = {
        form_id: event.data.id ,
        form_name: form_name,
        lead_category: form_category,

        // user: {
        //   email: values.email || "",
        //   first_name: values.firstname || "",
        //   last_name: values.lastname || "",
        //   phone: values.phone || "" 
        // }
      };

      console.log("Custom contact_lead payload:", payload);

      Shopify.analytics = Shopify.analytics || {};
      Shopify.analytics.publish =
        Shopify.analytics.publish || function () {};

      Shopify.analytics.publish("contact_lead", payload);
    }
  });
})();


//script for view item list 
window.dataLayer = window.dataLayer || [];

document.addEventListener("DOMContentLoaded", function () {
  // prevent duplicate firing
  if (window.__viewItemListFired) return;

  const productCards = document.querySelectorAll('[data-product-card]'); 
  if (!productCards.length) return;

  const items = [];

  productCards.forEach((card, index) => {
    const productId = card.dataset.productId || "";
    const variantId = card.dataset.variantId || "";
    const itemId = productId && variantId
      ? `shopify_us_${productId}_${variantId}`
      : "";
    items.push({
      item_id: itemId,
      item_name: card.dataset.title || "",
      price: Number(card.dataset.price || 0),
      index: index + 1
    });
  });

  if (!items.length) return;


//   window.dataLayer.push({
//     event: "view_item_list",
//     ecommerce: {
//       item_list_name: document.title.includes("Search") ? "Search Results" : "Collection",
//       currency: Shopify.currency.active,
//       items
//     }
//   });

    const payload = {
    currency: Shopify?.currency?.active || "USD",
    item_list_name: document.title.includes("Search")
      ? "Search Results"
      : "Collection",
    items: items
  };


  gtag("event", "view_item_list", payload);


  window.__viewItemListFired = true;
});

// view_type pdp page event
document.addEventListener("DOMContentLoaded", function () {

  // product page check
  if (!window.ShopifyAnalytics?.meta?.product) return;

  // ensure gtag exists
  if (typeof gtag !== "function") {
    console.warn("gtag not loaded");
    return;
  }

  const product = ShopifyAnalytics.meta.product;

  console.log("product",product);

  const variant =
    product.variants?.find(v => v.id == product.selectedVariantId) ||
    product.variants?.[0];

  if (!variant) return;
  
  const itemId = `shopify_us_${product.id}_${variant.id}`;

  const payload = {
    view_type: "detail",
    currency: Shopify.currency.active || "USD",
    items: [{
      item_id: itemId,
      item_name: variant.name,
      price: Number(variant.price) / 100
    }]
  };
  console.log("payload",payload);
  gtag("event", "view_item", payload);
});

//view option for cards less than 5 
document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll("[data-product-card-option]");

  // only run if cards < 5
  if (!cards.length || cards.length >= 7) return;

  if (typeof gtag !== "function") {
    console.warn("gtag not available");
    return;
  }

  const currency = Shopify?.currency?.active || "USD";

 // prevents repeat firing
  const fired = new WeakSet();

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const card = entry.target;

        // prevent duplicate
        if (fired.has(card)) return;

        fired.add(card);
        obs.unobserve(card);

        const productId = card.dataset.productId || "";
        const variantId = card.dataset.variantId || "";

        const itemId = productId && variantId
          ? `shopify_us_${productId}_${variantId}`
          : "";

        const payload = {
          view_type: "option",
          currency,
          items: [{
            item_id: itemId,
            item_name: card.dataset.title || "",
            price: Number(card.dataset.price || 0)
          }]
        };

          console.log('payload',payload);

        gtag("event", "view_item", payload);
      });
    },
    {
      threshold: 0.5 // fires when 50% visible
    }
  );
  cards.forEach(card => observer.observe(card));
});
